document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`.search-input [name="q"]`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});


if(window.KC.page.isCartPage()) {
    let counter = 0;
    let selector = "cart-drawer"
    const interval = setInterval(() => {
        let element = document.querySelector(selector);
        if (element) {
            element.remove()
            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100); 
}